/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const JoinGroupMembership = zod.object({
  groupActorUuid: zod.uuid(),
  roles: zod.array(zod.string()),
  userActorUuid: zod.uuid(),
});

export type JoinGroupMembership = zod.input<typeof JoinGroupMembership>;
export type JoinGroupMembershipOutput = zod.output<typeof JoinGroupMembership>;
